import React, { useState } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { EmployeePageHeader, EmployeeSurface } from "../employee/components/EmployeePage";
import { tokens as t } from "../theme/tokens";

const EmployeeTraining: React.FC = () => {
  const [loaded, setLoaded] = useState(false);

  const handleIframeLoad = (event: React.SyntheticEvent<HTMLIFrameElement>) => {
    setLoaded(true);
    const iframe = event.currentTarget;
    const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;

    window.setTimeout(() => {
      const header = iframeDocument?.body?.shadowRoot?.querySelector(".vfrc-header");
      const content = header?.nextElementSibling as HTMLElement | null;
      if (content?.tagName === "DIV") content.style.height = "75vh";
    }, 2000);
  };

  return (
    <>
      <EmployeePageHeader
        eyebrow="Employee training"
        title="Meet Anna"
        description="Practice suggestive selling in a private, interactive training session."
      />

      <EmployeeSurface>
        <Box sx={{ px: { xs: 2, sm: 2.5 }, py: 2, borderBottom: `1px solid ${t.color.cardLine}` }}>
          <Typography variant="body2" color="text.secondary">
            Review the frequently asked questions, then use the launcher in the lower-right corner to begin.
          </Typography>
        </Box>
        <Box sx={{ position: "relative", minHeight: { xs: 620, sm: 680 }, bgcolor: t.color.paper }}>
          {!loaded && (
            <Box
              role="status"
              aria-live="polite"
              sx={{ position: "absolute", inset: 0, zIndex: 1, display: "grid", placeItems: "center", bgcolor: t.color.paper }}
            >
              <Box sx={{ textAlign: "center" }}>
                <CircularProgress size={28} />
                <Typography color="text.secondary" sx={{ mt: 1.5 }}>Loading training modules…</Typography>
              </Box>
            </Box>
          )}
          <Box
            component="iframe"
            src="/training.html"
            title="PaperlessNOW employee training"
            onLoad={handleIframeLoad}
            sx={{ display: "block", width: "100%", height: { xs: 620, sm: 680 }, border: 0 }}
          />
        </Box>
      </EmployeeSurface>
    </>
  );
};

export default EmployeeTraining;
